import { EmailRecipientBuilder } from "./email.builder";
import { DocumentReference } from "@angular/fire/firestore";

export class EmailRecipient {
  public readonly reference: DocumentReference;
  public name: string;
  public email: string;
  public phone: string;
  public description: string;
  public cities: string[];
  public venues: string[];
  public editedBy: string;
  public createdBy: string;
  public hasFullAccess: boolean;

  constructor(builder: EmailRecipientBuilder) {
    this.reference = builder.reference;
    this.name = builder.name;
    this.email = builder.email;
    this.phone = builder.phone;
    this.description = builder.description;
    this.cities = builder.cities;
    this.venues = builder.venues;
    this.editedBy = builder.editedBy;
    this.createdBy = builder.createdBy;
    this.hasFullAccess = builder.hasFullAccess;
  }

  toJSON() {
    return {
      name: this.name,
      email: this.email,
      phone: this.phone,
      description: this.description,
      cities: this.cities,
      venues: this.venues,
      editedBy: this.editedBy ? this.editedBy : null,
      createdBy: this.createdBy,
      hasFullAccess: this.hasFullAccess
    };
  }

  update() {
    this.reference.update(this.toJSON());
  }
  delete() {
    this.reference.delete();
  }
}
